import {Button} from 'components/Button';
import {Typography} from 'components/Typography';
import {getPrice} from 'core/helpers';
import {useEventBuyButtonConfig} from 'modules/events/hooks';
import {FC} from 'react';
import style from './style.module.scss';
import {useUpButtonOffsetForStickyPanel} from 'components/UpButton/hooks/useUpButtonOffsetForStickyPanel';
import {useRouter} from 'next/router';
import {useGetEventQuery} from 'modules/events/services';

export const EventBuyButtonMobile: FC = () => {
    const {query} = useRouter();
    const {data} = useGetEventQuery({id: query.slug as string});
    const event = data?.data;
    const buyButtonConfig = useEventBuyButtonConfig();

    useUpButtonOffsetForStickyPanel();

    if (!event) {
        return null;
    }

    return (
        <div className={style.main}>
            <Button className={style.button} textClassName={style.buttonText} isStretched={true} {...buyButtonConfig}>
                <Typography className={style.title} variant={'button-12-m-cl'}>
                    Купить билеты
                </Typography>
                <Typography className={style.price} variant={'button-14-m-cl'}>
                    {getPrice(event.price)}
                </Typography>
            </Button>
        </div>
    );
};
